<div>
  <label for="fileUpload">Upload File (First Row Must be Headers)</label>
  <input
    #fileInput
    type="file"
    class="form-control-file"
    style="display: none"
    id="fileUpload"
    (change)="onFileSelected($event)"
  />
  <div class="d-flex align-items-center">
    <button
      (click)="fileInput.click()"
      [disabled]="disabled"
      class="btn btn-primary m-0 p-1 px-2"
    >
      Choose File
    </button>
    <p class="mb-0 ml-2" *ngIf="file?.fileName">{{ file.fileName }}</p>
    <p class="mb-0 ml-2" *ngIf="!file?.fileName">No File Selected</p>
  </div>
</div>

<div *ngIf="file.headers.length > 0" class="mt-3">
  <h5>Map Required Fields</h5>

  <div *ngFor="let field of fieldsToMap">
    <label>{{ field | titlecase }} Column</label>
    <ng-select
      [disabled]="disabled"
      [items]="file?.headers"
      [(ngModel)]="file.mappedColumns[field]"
      [placeholder]="'-- Select Column --'"
      (change)="onMappingChange()"
    >
    </ng-select>
  </div>

  <h6 class="mt-3">Preview (first 5 rows)</h6>
  <div class="table-responsive">
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th *ngFor="let header of file.headers" class="text-nowrap">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of file.preview">
          <td *ngFor="let header of file.headers" class="text-nowrap">
            {{ row[header] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
